import { __assign } from "tslib";
import { combine, getTimeStamp, toServerDuration } from '@datadog/browser-core';
import { ActionType, RumEventType } from '../../../rawRumEvent.types';
import { LifeCycleEventType } from '../../lifeCycle';
import { trackActions } from './trackActions';
export function startActionCollection(lifeCycle, configuration) {
    lifeCycle.subscribe(LifeCycleEventType.AUTO_ACTION_COMPLETED, function (action) {
        return lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, processAction(action));
    });
    if (configuration.trackInteractions) {
        trackActions(lifeCycle);
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, __assign({ savedCommonContext: savedCommonContext }, processAction(action)));
        },
    };
}
function processAction(action) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                error: {
                    count: action.counts.errorCount,
                },
                id: action.id,
                loading_time: toServerDuration(action.duration),
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = combine({
        action: {
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: getTimeStamp(action.startTime),
        type: RumEventType.ACTION,
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startTime,
    };
}
function isAutoAction(action) {
    return action.type !== ActionType.CUSTOM;
}
//# sourceMappingURL=actionCollection.js.map